module.exports = __webpack_public_path__ + "files/4fbaffc7deb01ce6b1aacff1f49ce109.png";